import React, { useEffect, useState } from 'react';
import '../CSS/Highlights.css';

const REPORT_TYPE = 'Threat Assessment Snapshot'; // what gets written to SharePoint

function logThreatClick(reportName, reportType = REPORT_TYPE) {
  const userEmail = localStorage.getItem('user-email');
  if (!userEmail) return;

  const payload = { reportName, reportType, userEmail };

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon('/api/log-report', blob);
    } else {
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload),
      }).catch(() => {});
    }
  } catch {}
}

const Highlights = () => {
  const [ThreatAssessment, setThreatAssessment] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  const addProxyUrls = (items) =>
    (items || []).map((item) => ({
      ...item,
      proxyUrl: `/api/highlights/ThreatAssessmentSnapshot/${encodeURIComponent(item.name)}.pdf`,
    }));

  useEffect(() => {
    let mounted = true;
    fetch('/api/hello')
      .then((r) => r.json())
      .then((data) => {
        if (!mounted) return;
        const withProxy = addProxyUrls(data?.ThreatAssessment || []);
        setThreatAssessment(withProxy);
        setFilteredData(withProxy);
      })
      .catch((err) => console.error('Error fetching reports data:', err))
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim()) {
      const t = term.toLowerCase();
      setFilteredData(
        ThreatAssessment.filter((item) =>
          item.name?.toLowerCase().includes(t)
        )
      );
    } else {
      setFilteredData(ThreatAssessment);
    }
  };

  if (loading) {
    return (
      <div className="highlights">
        <h1>Threat Assessment Snapshot</h1>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="highlights">
      <h1>Threat Assessment Snapshot</h1>

      <div className="box">
        <p>
          Brief intelligence assessments of potential hazards, vulnerabilities, and threats
          associated with a particular event or industry conference…
        </p>
      </div>

      {/* ✅ EXACT SAME SEARCH SETUP AS OTHER PAGES */}
      <label className="highlights-search">
        Search:&nbsp;
        <input
          type="text"
          placeholder="Search by title"
          value={searchTerm}
          onChange={handleSearch}
        />
      </label>

      <ul className="list-item">
        {filteredData.map((item, index) => (
          <li key={item.id || index}>
            <a
              href={item.proxyUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                const cleanName = (item.name || '').replace(/\.pdf$/i, '');
                logThreatClick(cleanName);
              }}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>

      {filteredData.length === 0 && <p>No reports found.</p>}
    </div>
  );
};

export default Highlights;
